export default __webpack_public_path__ + "static/media/empty-circle.06dd13fe.svg";